import { Flex, Heading, useTheme } from '@vitvio/design-system';
import { TimerContentStatusBadge } from './TimerContentStatusBadge';
import { TimerContentLeftDetails } from './TimerContentLeftDetails';
import { TimerContentRightDetails } from './TimerContentRightDetails';
import { graphql, useFragment } from 'react-relay';
import type { TimerContentPanelFragment$key } from './__generated__/TimerContentPanelFragment.graphql';
import { TimerContentUpdateInput } from './TimerContentUpdateInput';

const fragment = graphql`
  fragment TimerContentPanelFragment on Job {
    status
    ...TimerContentLeftDetailsFragment
    ...TimerContentRightDetailsFragment
    ...TimerContentStatusBadgeFragment
    ...TimerContentUpdateInputFragment
  }
`;

interface Props {
  category: 'SURGERY' | 'TURNOVER';
  fragmentRef: TimerContentPanelFragment$key | undefined;
}
export function TimerContentPanel({ fragmentRef, category }: Props) {
  const data = useFragment(fragment, fragmentRef);
  const { getColor, getRadius, getSpacing } = useTheme();
  function getPanelHeading() {
    if (data?.status === 'COMPLETED') {
      return 'Completed ';
    }
    if (data?.status === 'RUNNING') {
      return 'Estimated ';
    }
    return 'Planned ';
  }

  return (
    <Flex
      flexDir={'column'}
      bg={getColor('bg')}
      border={'solid 1px'}
      borderColor={getColor('border')}
      mb={getSpacing('5')}
      p={getSpacing('5')}
      borderRadius={getRadius('lg')}
      gap={getSpacing('4')}
    >
      <Flex justifyContent={'space-between'}>
        <Heading
          fontSize="xl"
          fontWeight={'semibold'}
        >{`${getPanelHeading()} ${category?.toLowerCase()} duration`}</Heading>
        {data?.status === 'COMPLETED' && <TimerContentStatusBadge fragmentRef={data || undefined} />}
      </Flex>
      <Flex
        justifyContent="space-between"
        bg={data?.status === 'RUNNING' ? getColor('bg.accent') : getColor('bg.base')}
        borderRadius={getRadius('lg')}
        p={getSpacing('5')}
        mb={getSpacing('2')}
      >
        <TimerContentLeftDetails fragmentRef={data || undefined} />
        <TimerContentRightDetails category={category} fragmentRef={data || undefined} />
      </Flex>
      <TimerContentUpdateInput fragmentRef={data || undefined} />
    </Flex>
  );
}
